import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  TextInput,
} from "@touchtech/web-baselayer-ui";

import css from "./ParkBasketModal.module.css";
import useManageParkBasketModal from "./hooks/useManageParkBasketModal";

type Props = {
  isOpen?: boolean;
  setIsOpen: (isOpen: boolean) => void;
  openFailedModal?: () => void;
  sessionName?: string;
};

const ParkBasketModal = ({
  isOpen,
  setIsOpen,
  openFailedModal,
  sessionName,
}: Props) => {
  const { t, handleSave, handleCloseModal, isPending, name, handleNameChange } =
    useManageParkBasketModal({
      setIsOpen,
      openFailedModal,
      sessionName,
    });

  return (
    <ConfirmationModal isOpen={isOpen} onClose={handleCloseModal}>
      <div className={css.modalContent}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {t("Park your basket")}
        </h1>
        <span className={classcat(["text-label-xl", css.text])}>
          {t(
            "Enter a name for the basket. The basket will be expired in 45 minutes."
          )}
        </span>
        <div className={css.inputContainer}>
          <TextInput
            label={t("Name")}
            width="full"
            placeholder={t("Enter basket name")}
            value={name}
            onChange={handleNameChange}
            autoCapitalize="sentences"
          />
        </div>
        <Button
          className={css.okButton}
          width="full"
          sizing="lg"
          onClick={handleSave}
          state={isPending ? "pending" : undefined}
        >
          {t("Apply and reset search")}
        </Button>
        <Button
          className={css.cancelButton}
          variant="tertiary"
          width="full"
          sizing="lg"
          onClick={handleCloseModal}
          state={isPending ? "disabled" : undefined}
        >
          {t("Cancel")}
        </Button>
      </div>
    </ConfirmationModal>
  );
};

export default ParkBasketModal;
